import { ChangeEvent } from "react";
import { Button } from '../Button/Button.page';
import { Stack } from '../../Layouts';
import { Label } from '../../Display';
import { useDisabledField } from '../../HookForm';
import { InputTextFieldProps } from '../../HookForm/InputTextField/InputTextField.types';
import { useFormContext } from 'react-hook-form';
import { getHelperTextMessage } from '../../HookForm/InputTextField/InputTextField.utils';

interface StepperInputProps extends InputTextFieldProps {
  min?: number;
  max?: number;
  step?: number;
  disable?: {plus?: boolean, min?: boolean};
  required?: boolean
  error?: boolean
  label?: string
  onChangeVal?: (_: { name: string, val: number, type: 'inc' | 'dec' }) => void
}

export function InputNumberMinPlus({
  max = undefined,
  min = 0,
  step = 1,
  label,
  required,
  disable,
  disabled,
  name,
  rule,
  onChangeVal,
  ...props
}: StepperInputProps) {

  const isDisabled = useDisabledField(name);
  const form = useFormContext();
  const error = form.formState.errors[name];
  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    return event.target.value
  };
  const register = form.register(name, {
    validate: validateForm(rule?.required),
    onChange,
    ...rule
  });

  function validateForm(required?: any) {
    return (value: any) => {
      if (!required && !value) {
        return (undefined);
      }
    }
  }

  const handleRef = (ref: HTMLInputElement | null) => {
    register.ref(ref);
  };

  const value = form.getValues(name)

  const increment = () => {
    form.setValue(name, value + step); onChangeVal && onChangeVal({ name, val: value + step, type: 'inc' });
  };

  const decrement = () => {
    if (value - step >= min) { form.setValue(name, value - step); onChangeVal && onChangeVal({ name, val: value - step, type: 'dec' }) };
  };

  return (
    <div className='' ref={handleRef}>
      <Stack direction='row' className='items-center w-max'>
        <Button
          onClick={decrement}
          disabled={(isDisabled || disabled || disable?.min) || value <= min}
          pill
          className='p-0 flex items-center h-5 w-5'
        >&#8212;</Button>
        <div className='text-black w-[3ch]'>{value}</div>
        <Button
          onClick={increment}
          disabled={(isDisabled || disabled || disable?.plus) || (max ? value >= max : false)}
          pill
          className='p-0 flex items-center h-5 w-5'
        >&#43;</Button>
      </Stack>
      {(props.error ?? !!error) && <Label error={props.error ?? !!error} required={!!rule?.required}>{props.helperText ?? getHelperTextMessage(error, props)}</Label>}
    </div>
  );
};

export default InputNumberMinPlus;
